module.exports = __webpack_public_path__ + "img/vertical_6_7_8003.e1c05d3e.png";